module.exports = __webpack_public_path__ + "img/bottom-rip.a8754d24.svg";